import React from 'react';
import { InteractionComponent } from '../../../../components/DesignSystem/AtomicComponents/CartButton/CartButton.styles';
import { MinusIcon } from '@/assets/svgExports/MinusIcon';

function LeftCartButton(props) {
  const { handleCart, isPDPPage } = props;
  return (
    <InteractionComponent
      position="left:14px;"
      width="30px"
      isPDPPage={isPDPPage}
      onClick={(e) => {
        e.stopPropagation();
        handleCart('dec');
      }}
    >
      <MinusIcon iconWidth={props?.iconWidth} />
    </InteractionComponent>
  );
}

export default LeftCartButton;
